<mg-table [collectionComponent]="this" matSort stickyHeaders>

    <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
        <td style="max-width: 15em;" mat-cell *matCellDef="let row"> {{row.status}} </td>
    </ng-container>
    
    <ng-container matColumnDef="op">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Op </th>
        <td mat-cell *matCellDef="let row"> {{row.op | date:'medium'}} </td>
    </ng-container>

    <ng-container matColumnDef="door">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Door </th>
        <td mat-cell *matCellDef="let row"> {{row.door}} </td>
    </ng-container>

</mg-table>
